import { is } from '@common/is/is'

import type { TTrackLimit } from '../definitions'

/**
 * Van még szabad sáv a kulcshoz?
 * @param key                      - Hangforrás kulcsa.
 * @param usedTracks               - Ennyi sávon játszódik az adott hang.
 * @param customMaxTracksPerSource - Forrásonként használható sávok.
 * @param maxTracksPerSource       - Globális forrásonként használható sávok.
 */
export default function hasFreeTrack ( // eslint-disable-line @typescript-eslint/max-params
  key: string,
  usedTracks: number,
  customMaxTracksPerSource: TTrackLimit,
  maxTracksPerSource: number | undefined
): boolean {
  // ha van definiálva limit, ráadásul kulcsonként, és tartozik a kulcshoz limit
  if (key in customMaxTracksPerSource) {
    return customMaxTracksPerSource[key] > usedTracks
  }

  // ha a limitet számban határoztuk meg, globálisan, akkor megvizsgáljuk.
  if (is.number(maxTracksPerSource)) {
    return maxTracksPerSource > usedTracks
  }

  return true
}
